import { EFavoritesActionType, IFavoriteParameters } from './types';
import { incrementHeaderFavorites } from './utils/updateHeaderFavorites';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const favoriteAdd = actionGenerator<EFavoritesActionType.Added, IFavoriteParameters>(EFavoritesActionType.Added);

export function addFavorite(offerId: number): TThunkAction<Promise<void>> {
  return async dispatch => {
    dispatch(favoriteAdd({ offerId }));
    incrementHeaderFavorites();
  };
}
